import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { NavigationService } from "@app/services/navigation.service";
import { INote } from "@foundation/_services/notes.service.ajs";
import { IUser } from "@interfaces/IUser";
import { CurrentUserService } from "@services/currentUser.service";
import { NoteType } from "../../_enums/NoteType";
import "./foundation-notes-list.component.scss";
import { FoundationNotesService } from "../../_services/notes.service";
import { Subject, Subscription } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ResourceType } from "../../_enums/ResourceType";

@Component({
    selector: "foundation-notes-list",
    template: require("./foundation-notes-list.component.html")
})

export class FoundationNotesListComponent implements OnInit, OnChanges {

    // Bindings

    @Input() type: ResourceType;
    @Input() entityId: number;

    // Internal

    tabCount: number = 0;

    loading = false;
    currentUser: IUser;

    notes: INote[];
    showNoteForm: boolean;
    noteToAdd: string;

    dataSubscription: Subscription;

    private destroy$ = new Subject<void>();

    constructor(
        private readonly notesService: FoundationNotesService,
        private readonly currentUserService: CurrentUserService,
        private readonly navigationService: NavigationService) {
    }

    ngOnInit(): void {
        this.getCurrentUser();
        this.updateNotes();
    }

    ngOnChanges(): void {
        this.updateNotes();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    toggleNoteForm(): void {
        this.showNoteForm = !this.showNoteForm;
    }

    addNote(): void {
        this.loading = true;

            const note: INote = {
                Comments: this.noteToAdd,
                ResourceId: this.entityId,
                ResourceType: this.type || 0, 
                NoteType: NoteType.Manual,
                CreatedOn: new Date().toISOString(),
                CreatedByUserId: this.currentUser?.Id
            };

        this.notesService.addNote(note).pipe(take(1)).subscribe(() => {
            this.showNoteForm = false;
            this.noteToAdd = "";
            note.UserName = this.currentUser.CurrentAccountUserMapping?.Name || this.currentUser.Email;
            this.notes.unshift(note);

            this.loading = false;
        })
    }

    // ---

    private getCurrentUser(): void {
        this.currentUserService.getCurrentUser().then(user => {
            this.currentUser = user;
        })
    }

    private updateNotes(): void {
        this.loading = true;
        const type = this.type || ResourceType.Account;

        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }

        this.dataSubscription = this.notesService.getNotes(this.entityId, type, NoteType.Manual).pipe(takeUntil(this.destroy$)).subscribe(notes => {
            this.notes = notes;
            this.tabCount = this.notes?.length;
            this.loading = false;
        })

    }
}
